import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/certificaciones.jpg'

// import cert1 from '../assets/images/certificaciones/c1b.jpg'
import cert2 from '../assets/images/certificaciones/cav.jpg'
import cert3 from '../assets/images/certificaciones/c3b.jpg'
import cert4 from '../assets/images/certificaciones/c4b.jpg'
import cert5 from '../assets/images/certificaciones/c5b.jpg'
import cert61 from '../assets/images/certificaciones/c6b1.jpg'
import cert62 from '../assets/images/certificaciones/c6b2.jpg'
import cert63 from '../assets/images/certificaciones/c6b3.jpg'
import cavIso90012015 from '../assets/pdf/cav_iso_9001_2015_2025.pdf'

export default function Certificaciones() {
    return (
        <>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h1 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Certificaciones</h1>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/quienessomos">Quiénes somos</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Certificaciones</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    {/* <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert1} alt="Certificación 1" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>
                                RECERTIFICACIÓN DEL CONSEJO DE SALUBRIDAD GENERAL
                            </h3>
                            <p className='text-muted'>
                                El Hospital Aranda de la Parra se encuentra Certificado por el Consejo de Salubridad General desde 2012 cuando los estándares de evaluación fueron homologados con estándares internacionales con enfoque en la seguridad de los pacientes. El Hospital Aranda de la Parra con el compromiso de mantener una cultura de calidad con la participación de todos sus colaboradores, logra la recertificación por la implementación del Modelo de Seguridad del Paciente del Sistema Nacional de Certificación de Establecimientos de Atención Médica en Diciembre de 2017.

                            </p>
                        </div>
                    </div> */}
                    <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert2} alt="Certificación 2" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>CERTIFICACIÓN ISO 9001:2015</h3>

                            <p className='text-muted'>
                                Reafirmamos nuestro compromiso con la excelencia, al obtener la certificación ISO 9001:2015, un reconocimiento internacional que avala la eficacia de nuestro Sistema de Gestión de la Calidad. Este logro refleja el esfuerzo y la dedicación de nuestro equipo para ofrecer una atención segura, eficiente y centrada en nuestros pacientes, impulsando la mejora continua en cada uno de nuestros procesos.
                            </p>

                            <a href={cavIso90012015} className="btn btn-success btn-sm" target="_blank" rel="noreferrer">
                                Ver certificación
                            </a>

                        </div>
                    </div>
                    <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert3} alt="Certificación 3" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>
                                CERTIFICACIÓN M100 MICROSOFT
                            </h3>
                            <p className='text-muted'>
                                En el Hospital Aranda de la parra estamos comprometidos con la legalidad en nuestro país por lo que poseemos software 100% original, respaldados por la empresa informática más grande del mundo, con la certificación M100.
                            </p>
                        </div>
                    </div>
                    <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert4} alt="Certificación 4" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>
                                ACREDITACIÓN 15189-2022
                            </h3>
                            <p className='text-muted'>
                                Entidad Mexicana de Acreditación A.C. es la primera entidad de gestión privada en nuestro país, que tiene como objetivo acreditar a los Organismos de la Evaluación de la Conformidad que son los laboratorios de ensayo, laboratorios de calibración, laboratorios clínicos, unidades de verificación (organismos de inspección) y organismos de certificación, Proveedores de Ensayos de Aptitud y a los Organismos Verificadores/Validadores de Emisión de Gases Efecto Invernadero (OVV GEI)
                            </p>
                        </div>
                    </div>
                    <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert5} alt="Certificación 5" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>
                                RECONOCIMIENTO 1.- LUGAR EN TASA DE DONACIÓN DE ÓRGANOS
                            </h3>
                            <p className='text-muted'>
                                El Gobierno del Estado de Guanajuato a través de la Secretaría de Salud le otorgó el reconocimiento por el 1er. Lugar en tasa de Donación de órganos a Nivel Nacional por 5 años consecutivos beneficiando a más de tres mil personas con un trasplante.
                            </p>
                        </div>
                    </div>
                    <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert61} alt="Certificación 6" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>
                                IAEA (ORGANISMO INTERNACIONAL DE ENERGIA ATOMICA)
                            </h3>
                            <p className='text-muted'>
                                Los resultados de la auditoría de dosimetría están dentro de nuestro límite de aceptación del 5% y no se requieren acciones adicionales.
                            </p>
                        </div>
                    </div>
                    <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert62} alt="Certificación 6" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>
                                IAEA MEDIDAS CON RPLD EN HACES DE Co-60 Y FOTONES DE ALTA-ENERGIA
                            </h3>
                            <p className='text-muted'>
                                Se considera satisfactoria una concordancia dentro del intervalo +/-5% entre la Dosis determinada por el usuario y la Dosis medida por el OIEA.
                            </p>
                        </div>
                    </div>
                    <div className="row mt-4 py-3 justify-content-center">
                        <div className="col-md-3 col-6 text-center">
                            <img src={cert63} alt="Certificación 6" className="img-fluid rounded border border-1 mt-md-1 mt-3 mb-3 mx-auto" />
                        </div>
                        <div className="col-md-9 col-12">
                            <h3 className='h5 text-primary'>
                                IAEA
                            </h3>
                            <p className='text-muted'>
                                En Unidad de Radiacción Varian Clinac iX #3540, Varian Clinac iX #4157
                            </p>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
